import { render, staticRenderFns } from "./stevedoring-account.vue?vue&type=template&id=87531772&"
import script from "./stevedoring-account.vue?vue&type=script&lang=js&"
export * from "./stevedoring-account.vue?vue&type=script&lang=js&"
import style0 from "./stevedoring-account.vue?vue&type=style&index=0&id=87531772&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87531772')) {
      api.createRecord('87531772', component.options)
    } else {
      api.reload('87531772', component.options)
    }
    module.hot.accept("./stevedoring-account.vue?vue&type=template&id=87531772&", function () {
      api.rerender('87531772', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics/stevedoring/stevedoring-account.vue"
export default component.exports